import { api, throwApiError } from "../../api/api";

export type SimulatorStore = { id: string; name: string; state: string | null };

/** Lojas do simulador (rota pública, sem login): só id, nome e estado. */
export const getSimulatorStoresApi = async (): Promise<SimulatorStore[]> => {
  try {
    const { data } = await api.get<SimulatorStore[]>("/public/simulador-escala/lojas");
    return data;
  } catch (error) {
    return throwApiError(error, "Não foi possível carregar as lojas.");
  }
};
